import React, {useEffect} from 'react';
import {Modal} from "../../../../../components/modal/modal.jsx";
import { FaExternalLinkAlt } from "react-icons/fa";
import ReportUtils from "../../../../../utils/report-utils.js";
import ProjectUtils from "../../../../../utils/project-utils.js";

const BASENAME = import.meta.env.BASE_URL;

const ModalDetailsContent = ({ open, setOpen, data, boName, hasPermission }) => {

    useEffect(() => {
        ReportUtils.withoutContentReadjust();
    }, [data]);

    return (
        <Modal open={open} setOpen={setOpen} title={`Envolvidos em apreensões - ${data.type}`} isCloseClick={true}>
            <Modal.Body className="pt-0 !m-0 align-self-center justify-items-center">
                <table className="table report-table my-4">

                    <thead className="thead-background">
                        <tr className="bg-[#f6f6f6] text-left">
                            <th className="w-[10%]">{boName}</th>
                            <th className="w-[15%]">CPF</th>
                            <th className="w-[67%]">Nome</th>
                            <th className="w-[3%]"></th>
                        </tr>
                    </thead>

                    <tbody className="bg-white">
                        { data?.ind_info?.map((element, index) => {
                            const id = element.id.replace('/', '-').replace(' ', '');
                            const validateCpf = element.cpf && element.cpf !== '[]' && element.cpf.length === 11;
                            const validateName = element.name && element.name.trim() !== '[]';
                            const allowInteraction = validateCpf;

                            return (
                                <tr key={index}>
                                    <td className="w-[10%]">{hasPermission ? ( <a href={`${BASENAME}bo/redirect/${id}`} target={"_blank"} className={'inner-link'} title={`Acessar ${boName} - ${element.id}`}>{element.id}</a> ) : element.id}</td>
                                    <td className="w-[15%]">{ProjectUtils.formatCpfToView(element.cpf.trim())}</td>
                                    <td className="w-[67%]">{validateName ? ReportUtils.formatText(element.name) : element.name}</td>
                                    <td className="w-[3%]">
                                        <FaExternalLinkAlt
                                            size={15}
                                            title={allowInteraction ? `Ir para cadastro de ${ReportUtils.formatText(element.name)}` : 'CPF não informado'}
                                            className={allowInteraction ? 'details-link cursor-pointer' : 'text-[#8F8F8F8F] cursor-not-allowed'}
                                            onClick={() => {
                                                if (!allowInteraction) return;
                                                window.open(`${BASENAME}individuals/form/${element.cpf}`, "_blank");
                                            }}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </Modal.Body>
        </Modal>
    );
};

export default ModalDetailsContent;